import React from 'react'
import DashboardLayout from '../../layout/DashboardLayout'
import { Box } from '@mui/material'
import TeamsList from './TeamsList'
const Teams = () => {
  return (
    <DashboardLayout pageName="Profile">
      <Box sx={{ display: 'flex', py:1, flexDirection: { xs: 'column', sm: 'column', md: 'row' }}}>
        <TeamsList />
      </Box>
    </DashboardLayout>
  )
}

export default Teams